<template>
    <v-container>
        <v-card id="searchDiv" v-show="show">
            <v-toolbar color="cyan" dark>
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <slot name="searchForm">
                <v-form @keyup.enter.native="onSearch">
                    <v-layout wrap>
                        <v-flex xs6 style="padding:10px">
                            <c-textbox :label="$t('lang.task.taskname')"
                                       v-model="values['name']" :autofocus="true"></c-textbox>
                        </v-flex>
                        <v-flex xs6 style="padding:10px">
                            <i-selectbox v-model="values['processDefinitionId']" select-all
                                         source="select process_definition_id,flow_name from workflow where status=1"
                                         item-value="process_definition_id" item-text="flow_name" :label="$t('lang.workflow.name')"/>
                        </v-flex>
                    </v-layout>
                </v-form>
                <div style="text-align: center;">
                    <v-btn color="primary" dark @click="onSearch">
                        <v-icon dark left>search</v-icon>
                        {{$t('lang.common.search')}}
                    </v-btn>
                    <v-btn color="red" dark @click="createNew">
                        <v-icon dark left>add</v-icon>
                        {{$t('lang.common.add')}}
                    </v-btn>
                </div>
            </slot>
            <slot name="tableData">
                <v-data-table :items="items" :headers="fields"
                              :total-items="totalRows"
                              :rows-per-page-items="rowsPerPageItems"
                              :pagination.sync="pagination"
                              @update:pagination="onPaging">
                    <template slot="headers">
                        <th v-for="header in fields" :width="header.width" :style="header.headerStyle">
                            <v-checkbox v-if="header.value=='checkbox'" color="primary" hide-details ></v-checkbox>
                            <div v-else>
                                {{$t(header.text)}}
                            </div>
                        </th>
                    </template>
                    <template slot="items" slot-scope="data">
                        <td v-for="header in fields">
                            <div v-if="header.value=='index'" style="text-align: center;">
                                {{(pagination.page-1)*pagination.rowsPerPage + data.index+1}}
                            </div>
                            <div v-else-if="header.compound==undefined || header.compound ==false">
                                <div v-if="header.dateFormat != undefined">
                                    {{displayDate(data.item[header.value],header.dateFormat) }}
                                </div>
                                <div v-else>
                                    {{data.item[header.value]}}
                                </div>
                            </div>
                            <div v-else-if="header.value=='action'" style="text-align: center">
                                <v-btn depressed outline icon fab dark color="primary" small @click="editItem(data)">
                                    <v-icon>build</v-icon>
                                </v-btn>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </slot>
        </v-card>
        <FlowSelect></FlowSelect>
        <!--TaskView /-->
        <!--FormSubmit></FormSubmit-->
        <FormInput></FormInput>
        <TaskView></TaskView>


    </v-container>
</template>

<script>
    import CTextbox from "../../../components/form/Textbox";
    import axios from "axios";
    import FlowSelect from "./FlowSelect";
    import VueController from "../../../../public/js/controller";
    import TaskView from "./TaskView";
    import FormSubmit from "./FormSubmit";
    import FormInput from "./FormInput";
    import ISelectbox from "../../../components/form/SelectBox";

    export default {
        name: 'task-management',
        components: {ISelectbox, FormInput, FormSubmit, TaskView, FlowSelect, CTextbox},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'lang.task.title'
            },
            searchUrl: {
                type: String,
                default: "/task/search"
            },
            createUrl: {
                type: String,
                default: "/task/create"
            },
            deleteUrl: {
                type: String,
                default: ""
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 5, 20, 30, 40, 50]
            }
        },

        data: () => {
            return {
                inputSearchItems: [
                    {
                        type: "text",
                        name: "name",
                        label: "lang.task.taskname",
                        focus:true
                    },
                    {
                        type: "text",
                        name: "processDefinitionId",
                        label: "lang.workflow.code"
                    }
                ],
                fields: [
                    {value: "index", text: "lang.common.index", sortable: false, headerStyle:"text-align:center"},
                    {value: 'name', text: 'lang.task.taskname', sortable: false, headerStyle:"text-align:left"},
                    {value: 'workflowName', text: 'lang.workflow.name', sortable: false, headerStyle:"text-align:left"},
                    {value: 'assignnee', text: 'lang.task.assignnee', sortable: false,headerStyle:"text-align:left"},
                    {value: 'owner', text: 'lang.task.owner', sortable: false,headerStyle:"text-align:left"},
                    {value: 'createTime', text: 'lang.common.create_at', sortable: false, dateFormat: 'dd/MM/yyyy hh:mm',headerStyle:"text-align:left"},
                    {value: 'dueDate', text: 'lang.task.duedate', sortable: false, dateFormat: 'dd/MM/yyyy hh:mm',headerStyle:"text-align:left"},
                    {value: 'action', text: "lang.common.actions", sortable: false, compound: true, headerStyle:"text-align:center"}
                ],
                show:true,
                values: {},
                items: [],
                model: {},
                selectFlowDlg: false,
                formDlg:false,
                pagination: {
                    rowsPerPage: 20
                },
                selectedItem: {},
                totalRows: 0
            }
        },

        created() {
            VueController.push(this,"taskManager");
            console.log(this.$route.params);
            if(this.$route.params.processDefinitionId != undefined){
                this.values["processDefinitionId"] = this.$route.params.processDefinitionId;
                //this.$set(this,"values",this.values);
            }
            //console.log(VueController);
            this.search();
        },

        destroyed(){
            VueController.removeComponentByEl(this);
            //console.log(VueController);
        },

        methods: {
            onSearch: function () {
                //this.currentPage = 1;
                this.pagination.page = 1;
                this.search();
            },

            displayDate: function (data, format) {
                if(data == null){
                    return "";
                }
                let dateDate = new Date(data);
                let month = dateDate.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let year = dateDate.getFullYear();
                let date = dateDate.getDate();
                if (date < 10) {
                    date = "0" + date;
                }
                let second = dateDate.getSeconds();
                let minute = dateDate.getMinutes();
                let hour = dateDate.getHours();
                let dateStr = format.replace("dd", date).replace("MM", month).replace("yyyy", year).replace("mm", minute).replace("hh", hour).replace("ss", second);
                return dateStr;
            },

            search: function () {
                axios.post(process.env.VUE_APP_API_URL + this.searchUrl + "?pageSize=" + this.pagination.rowsPerPage + "&page=" + this.pagination.page, this.values).then((data) => {
                    //console.log("-after post get data");
                    //console.log(data);
                    this.items = data.items;
                    this.totalRows = data.count;
                    //console.log(this.pagination);
                });
            },

            onPaging: function (page) {
                this.pagination = page;
                this.search();
            },

            isEmpty: function (obj) {
                for (let key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },

            createNew: function () {
                let selectFlowDlg = VueController.getComponentByComponentName("flow-select");
                selectFlowDlg.onShow(true);
                //this.selectFlowDlg = true;
            },

            editItem: function (data) {
                let viewComponent = VueController.getComponentByComponentName("task-view");
                this.show = false;
                viewComponent.onView(data.item);
            },

            showCreateForm: function (item) {
                document.getElementById("searchDiv").style.display = "none";
                document.getElementById("createDiv").style.display = "";
                this.selectedItem = item;
                if (!this.isEmpty(this.$slots)) {
                    console.log("here");
                    let child = this.$slots.createForm[0].componentInstance;
                    child.onView(item);
                }
            },

            deleteItem: function (data) {
                if (confirm("Do you want to delete")) {
                    //let header = {headers:new authHeader()};
                    axios.post(process.env.VUE_APP_API_URL + this.deleteUrl, data.item).then(data => {
                        alert("delete success");
                        this.search();
                    }, error => {
                        alert("delete failed");
                    });
                };
            }

        }


    }
</script>